;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { UserRole } from "@/types/user";

/**
 * Canonical workspace permission resource keys and human-readable labels.
 * Single source of truth for API keys used in Workspace.permissions maps and WorkspacePermission.resource.
 */
export const WORKSPACE_PERMISSION_RESOURCE_LABELS = {
	aiAssistant: "AI Assistant",
	automation: "Automations",
	billing: "Billing",
	dashboards: "Dashboards",
	dataProvider: "Data Provider",
	organization: "Organization",
	users: "Users",
	viewSharing: "View Sharing",
	visualization: "Visualizations",
	workflow: "Workflow",
	workspace: "Workspace",
	workspaces: "Workspaces",
} as const;

export type WorkspacePermissionResourceKey =
	keyof typeof WORKSPACE_PERMISSION_RESOURCE_LABELS;

export const defaultPermissionsByRole = {
	[UserRole.ADMIN]: {
		aiAssistant: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		automation: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		dashboards: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		dataProvider: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		users: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		viewSharing: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		workflow: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		workspace: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
	},
	[UserRole.USER]: {
		aiAssistant: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		automation: {
			create: true,
			delete: true,
			edit: true,
			view: true,
		},
		dashboards: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		dataProvider: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		users: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		viewSharing: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		workflow: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
		workspace: {
			create: false,
			delete: false,
			edit: false,
			view: true,
		},
	},
};
